<div class="selection-container">
  <div odxLayout="flex gap-small">
    <h6 class="odx-title-6" i18n="@@localeSelection.header2">Sprache auswählen</h6>
    <odx-icon
      name="info"
      [odxTooltip]="tooltipLanguageSupport"
      odxTooltipSize="medium"
      [odxTooltipOptions]="{ position: 'bottom' }"
    />
  </div>

  <form odxForm [formGroup]="languageSelectionForm">
    <app-language-selection-form-field
      [formGroup]="languageSelectionForm"
      [languages]="(supportedLanguages$ | async) ?? []"
      (selectLanguage)="selectLanguage($event)"
    ></app-language-selection-form-field>
  </form>
</div>
